import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import { store } from './store'
import * as firebase from 'firebase'
import AlertCmp from './components/shared/Alert.vue'
import DateFilter from './filters/date'
Vue.config.productionTip = false
Vue.filter('date', DateFilter)
Vue.component('app-alert', AlertCmp)
new Vue({
  el:'#app',
  router,
  store,
  render: h => h(App),
  created(){
    firebase.initializeApp({
      apiKey: "AIzaSyAOYZ7uk6aX45PVpPGVzGKv78SCXvKe2W4",
      authDomain: "ql-testproject-1.firebaseapp.com",
      databaseURL: "https://ql-testproject-1.firebaseio.com",
      projectId: "ql-testproject-1",
      storageBucket: "gs://ql-testproject-1.appspot.com",
      timestampsInSnapshots: true
    }
  )
  const settings = { timestampsInSnapshots: true};
  firebase.firestore().settings(settings);
  firebase.auth().onAuthStateChanged((user)=>{
    if(user)
    {
      this.$store.dispatch("autoLogin",user);
    }
  })
  

  }
}).$mount('#app')
